module.exports = __webpack_public_path__ + "media/images/front/icon_db_200_hozon-ca5b1a311df316f5425bb378d6ae3fe4.png";